<template>
  <div class="d-flex-column justify-start align-start gap-8">
    <div class="d-flex-row justify-start gap-5">
      <label for="" class="t-light regular-l font-family-2">
        {{ $t("calculators_common.boost_type") }}
      </label>
      <ItemTooltip :text="$t('fc-boost.descriptions.boost_type')" />
    </div>
    <div class="d-flex-row boost_type_picker gap-0 space-between md-row-to-col">
      <button
        class="b-radius-6 height-36 type_picker cursor-pointer d-flex-row"
        :key="method.id"
        v-for="method in getKeyedPlatforms"
        role="button"
        @click.stop="() => selectMethod(method.title)"
        :class="[checkoutStore.details?.boostType == method.title && 'active']"
      >
        <label
          class="white-space-no t-white medium-l cursor-pointer font-family-2 f-w-500"
          >{{ method?.title }}</label
        >
      </button>
    </div>
  </div>
</template>

<script setup>
import DropDown from "~/components/custom/DropDown.vue";
import ItemTooltip from "./ItemTooltip.vue";
const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();
const getKeyedPlatforms = computed(() => {
  return gameStore.getGamePack?.pack_extra_options?.filter(
    (op) => op.description === "boosting_options"
  );
});

const selectMethod = (value) => {
  checkoutStore.setDetails({
    boostType: value,
  });
};
</script>

<style lang="scss">
.boost_type_picker {
  position: relative;
  width: 100%;
  padding: 2px;
  border-radius: 8px;
  background: var(--BG-Medium, #121517);
  .type_picker {
    padding: 8px 16px;
    border: 1px solid transparent;
    background-color: transparent;
    &.active {
      border: 1px solid var(--blue);
      background-color: var(--dark-blue);
      .server_icon {
        filter: saturate(100%);
      }
    }
  }
}
</style>
